import { Component } from '@angular/core';

@Component({
  selector: 'app-play-store-app-store-cta',
  templateUrl: './play-store-app-store-cta.component.html',
  styleUrl: './play-store-app-store-cta.component.scss',
  standalone: false
})
export class PlayStoreAppStoreCtaComponent {

}
